"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartFlagType = void 0;
var CartFlagType;
(function (CartFlagType) {
    CartFlagType["hasBundleProductCategories"] = "hasBundleProductCategories";
    CartFlagType["hasEnergy"] = "hasEnergy";
    CartFlagType["hasEnergyMobileSimBundle"] = "hasEnergyMobileSimBundle";
    CartFlagType["hasEnergyMobileSimNbnBundle"] = "hasEnergyMobileSimNbnBundle";
    CartFlagType["hasEnergyNbnBundle"] = "hasEnergyNbnBundle";
    CartFlagType["hasEnergyOnly"] = "hasEnergyOnly";
    CartFlagType["hasMobileSim"] = "hasMobileSim";
    CartFlagType["hasMobileSimNbnBundle"] = "hasMobileSimNbnBundle";
    CartFlagType["hasMobileSimOnly"] = "hasMobileSimOnly";
    CartFlagType["hasNbn"] = "hasNbn";
    CartFlagType["hasNbnOnly"] = "hasNbnOnly";
})(CartFlagType = exports.CartFlagType || (exports.CartFlagType = {}));
//# sourceMappingURL=cart-flag-type.enum.js.map